/**
 * Clinics store.
 *
 */

import { Module, Action, getModule } from 'vuex-module-decorators';
import PageBaseModule from '@/store/page';
import store from '@/store';
import PageEntity from '@/store/pageEntity';

import ClinicsFilter from './filterEntity';
import { Filter } from '@/types/filter/filter';
import filterModel from './filterModel';

import { getList } from '@/api/crud';
import ResponseHandlerModule from '@/store/modules/responseHandler';

import { Clinics } from '@/models/clinics';

export const MODULE_NAME = Clinics.moduleName;

@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class ClinicsModule extends PageBaseModule {
    filter: Filter;

    constructor(module: ClinicsModule) {
        super(module);

        const page = new PageEntity();
        page.setModuleName(Clinics.moduleName);
        page.setTitle(Clinics.listTitle);
        page.setTitleAdd(Clinics.createTitle);
        page.values.actionPagination = 'clinics/updatePage';
        page.values.actionPageAmountItems = 'clinics/updatePageAmountItems';
        page.values.pageAmountItems = 50;
        this.pageSettings = page.values;
        this.pageSettings.routeName = `${Clinics.moduleName}_edit`;
        this.pageSettings.routeParam = `${Clinics.moduleName}Id`;

        const filter = new filterModel();
        this.filter = getModule(ClinicsFilter);
        this.filter.setFilterName('clinicsFilter');
        this.filter.setTemplateClassName('template-lg');
        this.filter.setFilterModel(filter.filterModel);
        this.filter.setFilterHandlers(filter.filterHandlers);
    }

    @Action({ rawError: true })
    async init() {
        await this.getList();
    }

    @Action({ rawError: true })
    async getList() {
        try {
            const sort = await this.getSortForRequest();
            const result = await getList(
                Clinics.apiPrefix,
                {
                    page: this.pageSettings.pageCurrent,
                    items: this.pageSettings.pageAmountItems,
                },
                sort,
                this.filter.filterSettings.filter,
            );
            await this.context.dispatch('setList', result.table);
        } catch (clientError: any) {
            const error = clientError.response.data;

            ResponseHandlerModule.showNotify({ message: error.message, type: 'fail' });

            await this.context.dispatch('updatePage', 1);
        }
    }
}

export default getModule(ClinicsModule);
